import { atom } from "recoil";
import { MonitorServerEvent } from "../model";

export const lastMonitorsUpdatedState = atom<MonitorServerEvent[]>({
  key: "lastMonitorsUpdatedState",
  default: []
})